"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toIntegerOrNull = exports.toInteger = void 0;
var toInteger = value => parseInt(value, 10);
exports.toInteger = toInteger;
var toIntegerOrNull = value => typeof value === 'number' ? value : value != null && toInteger(value) || null;
exports.toIntegerOrNull = toIntegerOrNull;